import {
  Modal,
  Box,
  Grid,
  Typography,
  Button,
  IconButton,
  TextField,
  InputAdornment,
} from "@mui/material";
import PageHeader from "../ui/PageHeader";
import CustomTable from "../ui/CustomTable";
import CustomGridHeaderCell from "../ui/CustomGridHeaderCell";
import CustomInput from "../ui/CustomInput";
import { useIntl } from "react-intl";
import { useEffect, useState } from "react";
import axios from "../../api/axiosClient";
import { useLoading } from "../LoadingContext";
import { handleError, errorToast } from "../../services/serviceBase";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import BarcodeIcon from "../ui/BarcodeIcon";
import Checkbox from "@mui/material/Checkbox";
import toast from "react-hot-toast";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";

export default function BoxInQCModal(props) {
  const intl = useIntl();
  const { setLoading } = useLoading();

  const [columns, setColumns] = useState([]);
  const [boxInQCData, setBoxInQCData] = useState([]);
  const [initialData, setInitialData] = useState([]);
  const [boxInLabelling, setBoxInLabelling] = useState(false);
  const [checked, setChecked] = useState(true);
  const [scannedBox, setScannedBox] = useState({ Barcode: "", IsGen: false });
  const [boxGenButtonDisabled, setBoxGenButtonDisabled] = useState(false);

  const modalStyle = {
    position: "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
  };

  const handleClose = () => {
    props.handleCloseModal();
  };

  useEffect(() => {
    if (
      props.idReturnFileHead !== null &&
      props.idReturnFileHead !== undefined &&
      props.idReturnFileHead !== "" &&
      props.openModal
    ) {
      getBoxInQCData();
      setScannedBox({ Barcode: "", IsGen: false });
    }
  }, [props.openModal]);

  useEffect(() => {
    if (boxInQCData.length > 0) {
      getColumns();
      if (boxInQCData.map((x) => x.isGenericBox).some((x) => x == true)) {
        setBoxGenButtonDisabled(true);
        setScannedBox({ Barcode: "", IsGen: false });
      }
    }
  }, [boxInQCData, boxInLabelling]);

  const getBoxInQCData = async () => {
    setLoading(true);
    axios
      .get(`/returnfiles/${props.idReturnFileHead}/boxinqc`)
      .then((response) => {
        setLoading(false);

        const data = response.data.map((item, index) => {
          return {
            ...item,
            isTemp: false,
          };
        });

        setBoxInQCData(data);

        let initData = data.map((item) => {
          return { ...item };
        });
        setInitialData(initData);

        setBoxGenButtonDisabled(
          response.data.map((x) => x.isGenericBox).some((x) => x == true)
        );
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const saveOrUpdateBoxInQC = async () => {
    let model = boxInQCData;
    setLoading(true);
    let url = `/returnfiles/${props.idReturnFileHead}/boxinqc`;
    axios
      .post(url, model)
      .then((response) => {
        setLoading(false);
        toast.success("Saved!");
        //aggiorna dataset
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleGoBack = () => {
    if (!areDatasetEquals(initialData, boxInQCData)) {
      var message = intl.formatMessage({ id: "BoxKO.ConfirmGoBack" });
      if (!window.confirm(message)) {
        return false;
      }
    } else if (boxInQCData.map((x) => x.isTemp).some((x) => x == true)) {
      var message = intl.formatMessage({ id: "BoxKO.ConfirmGoBack" });
      if (!window.confirm(message)) {
        return false;
      }
    }
    handleClose();
  };

  const getGenericBoxId = async () => {
    setLoading(true);
    axios
      .get(`/returnfiles/boxinqc/boxinid`)
      .then((response) => {
        setLoading(false);
        setScannedBox({ Barcode: response.data, IsGen: true });
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  useEffect(() => {
    if (scannedBox.IsGen) {
      addRowInBoxIdQCDataset();
    }
  }, [scannedBox]);

  const addRowInBoxIdQCDataset = async () => {
    let newRow;
    if (scannedBox.IsGen) {
      newRow = {
        boxInId: scannedBox.Barcode,
        boxInQuantity: 0,
        boxInLabelling: true,
        boxInDimensions: false,
        boxInWeight: false,
        boxInIntegrity: false,
        boxInContent: false,
        isGenericBox: true,
        isTemp: true,
      };
      //setBoxGenButtonDisabled(true);
    } else {
      newRow = {
        boxInId: scannedBox.Barcode,
        boxInQuantity: 1,
        boxInLabelling: false,
        boxInDimensions: false,
        boxInWeight: false,
        boxInIntegrity: false,
        boxInContent: false,
        isGenericBox: false,
        isTemp: true,
      };
    }

    var newData = [...boxInQCData, newRow];
    setBoxInQCData(newData);
  };

  const handleDeleteRow = (boxInId, isTemp, isGen) => {
    var message = intl.formatMessage({ id: "BoxKO.Confirm" });
    if (!window.confirm(message)) {
      return false;
    }
    setLoading(true);
    if (isTemp) {
      let newDataset = [...boxInQCData];
      var item = newDataset.find((x) => x.boxInId == boxInId);
      if (item != null && item != undefined) {
        let idx = newDataset.indexOf(item);
        newDataset.splice(idx, 1);
        setBoxInQCData(newDataset);
        if (isGen) {
          setBoxGenButtonDisabled(false);
        }
      }
    } else {
      deleteRow(boxInId);
    }
    setLoading(false);
  };

  const deleteRow = (boxInId) => {
    axios
      .delete(
        `/returnfiles/${props.idReturnFileHead}/boxinqc/${boxInId}`
      )
      .then((response) => {
        setLoading(false);
        toast.success("Deleted!");
        window.location.reload();
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleBarcodeFilterChange = (barcode) => {
    if (barcode.includes("<") || barcode.includes(">")) {
      return;
    } else {
      setScannedBox({ Barcode: barcode, IsGen: false });
    }
  };

  function RenderCheckBox(props) {
    const [checked, setChecked] = useState(props.value);
    const [isReadonly, setIsReadonly] = useState(
      props.field == "boxInLabelling"
    );

    const handleChange = (event) => {
      setChecked(event.target.checked);
      let newDataset = [...boxInQCData];
      var item = newDataset.find((x) => x.boxInId == props.row.boxInId);
      item[props.field] = event.target.checked;
      setBoxInQCData(newDataset);
    };

    return (
      <Checkbox
        checked={checked}
        onChange={handleChange}
        disabled={isReadonly}
      />
    );
  }

  function RenderQuantityInput(props) {
    const [quantity, setQuantity] = useState(props.row.boxInQuantity);
    const [isReadonly, setIsReadonly] = useState(!props.row.isGenericBox);

    const handleQuantityChange = (event) => {
      setQuantity(event);
      let newDataset = [...boxInQCData];
      var item = newDataset.find((x) => x.boxInId == props.row.boxInId);
      item[props.field] = event;
      setBoxInQCData(newDataset);
    };

    return (
      <CustomInput
        type="number"
        value={quantity}
        setValue={(e) => {
          handleQuantityChange(e);
        }}
        inputCol={12}
        disabled={isReadonly}
      />
    );
  }

  function areDatasetEquals(data1, data2) {
    var data1Json = JSON.stringify(data1);
    var data2Json = JSON.stringify(data2);
    return data1Json == data2Json;
  }

  const getColumns = () => {
    setColumns([
      {
        field: "boxInId",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "BoxKO.BoxInId" })}
          />
        ),
        flex: 1.3,
      },
      {
        field: "boxInQuantity",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "BoxKO.BoxInQty" })}
          />
        ),
        flex: 1,
        renderCell: RenderQuantityInput,
      },
      {
        field: "boxInLabelling",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "BoxKO.BoxInLabelling" })}
          />
        ),
        flex: 1,
        renderCell: RenderCheckBox,
      },
      {
        field: "boxInDimensions",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "BoxKO.BoxInDimensions" })}
          />
        ),
        flex: 1,
        renderCell: RenderCheckBox,
      },
      {
        field: "boxInWeight",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "BoxKO.BoxInWeight" })}
          />
        ),
        flex: 1,
        renderCell: RenderCheckBox,
      },
      {
        field: "boxInIntegrity",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "BoxKO.BoxInIntegrity" })}
          />
        ),
        flex: 1,
        renderCell: RenderCheckBox,
      },
      {
        field: "boxInContent",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "BoxKO.BoxInContent" })}
          />
        ),
        flex: 1,
        renderCell: RenderCheckBox,
      },
      {
        field: "photoAction",
        type: "actions",
        headerClassName: "grid-header apeLigthBlueBackground",
        headerName: "Box In Photo",
        //resizable: true,
        flex: 1,
        renderCell: (params) => {
          return (
            <>
              <IconButton
                size="large"
                onClick={(e) =>
                  alert("add image")
                }
              >
                <AddPhotoAlternateIcon />
              </IconButton>
              <IconButton
                size="large"
                onClick={(e) =>
                  alert("view images")
                }
              >
                <FolderOpenOutlinedIcon />
              </IconButton>
            </>
          );
        },
      },
      {
        field: "deleteAction",
        type: "actions",
        headerClassName: "grid-header apeLigthBlueBackground",
        headerName: "",
        flex: 1,
        renderCell: (params) => {
          return (
            <IconButton
              size="large"
              onClick={(e) =>
                handleDeleteRow(
                  params.row.boxInId,
                  params.row.isTemp,
                  params.row.isGenericBox
                )
              }
            >
              <DeleteForeverIcon />
            </IconButton>
          );
        },
      },
    ]);
  };

  return (
    <Modal open={props.openModal} onClose={handleClose}>
      <Box sx={modalStyle}>
        <PageHeader
          title={
            intl.formatMessage({ id: "RADetails.BoxKO" }) +
            " - " +
            props.returnFileKey
          }
        />
        <Grid
          container
          style={{ height: "100%" }}
          alignItems="center"
          mt={1}
          mb={1}
        >
          <Grid item md={4} xs={12}>
            <Typography variant="normal">BOX IN</Typography>
          </Grid>
          <Grid item md={2} xs={12} pr={2}>
            <Button
              variant="outlined"
              sx={{ width: "100%" }}
              className="QcBlueButton"
              disabled={scannedBox.Barcode.length == 0}
              onClick={(e) => addRowInBoxIdQCDataset()}
            >
              {intl.formatMessage({ id: "BoxKO.Scan" })}
            </Button>
          </Grid>
          <Grid item md={4} xs={12} pr={2}>
            <TextField
              variant="outlined"
              size="small"
              value={scannedBox.Barcode}
              sx={{ width: "100%" }}
              onChange={(e) => {
                handleBarcodeFilterChange(e.target.value);
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <BarcodeIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item md={2} xs={12}>
            <Button
              variant="outlined"
              sx={{ width: "100%" }}
              className="QcBlueButton"
              disabled={boxGenButtonDisabled}
              onClick={(e) => getGenericBoxId()}
            >
              {intl.formatMessage({ id: "BoxKO.BoxGen" })}
            </Button>
          </Grid>
        </Grid>
        <CustomTable
          columns={columns}
          rows={boxInQCData}
          id={"boxInId"}
          rowHeight={50}
          headerHeight={50}
          tableHeight={420}
        />
        <Grid
          container
          style={{ height: "100%" }}
          alignItems="center"
          mt={1}
          mb={1}
        >
          <Grid item md={2} xs={12}>
            <Button
              variant="outlined"
              sx={{ width: "90%" }}
              onClick={handleGoBack}
            >
              {intl.formatMessage({ id: "BoxKO.Back" })}
            </Button>
          </Grid>
          <Grid item md={2} xs={12}>
            <Button
              variant="outlined"
              sx={{ width: "90%" }}
              onClick={(e) => saveOrUpdateBoxInQC()}
            >
              {intl.formatMessage({ id: "BoxKO.Save" })}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}
